"use strict";
exports.__esModule = true;
exports.toLocalizationFilter = exports.toLocalization = void 0;
var types_1 = require("../../types");
var LOCALIZATION_PRISMIC_TO_LGLP = {
    'Auvergne Rhône Alpes': types_1.Localization.AUVERGNE,
    'Bourgogne Franche Comté': types_1.Localization.BOURGOGNE,
    Bretagne: types_1.Localization.BRETAGNE,
    'Centre Val de Loire': types_1.Localization.CENTRE,
    Corse: types_1.Localization.CORSE,
    DOM: types_1.Localization.DOM,
    'Grand Est': types_1.Localization.GRAND_EST,
    'Hauts de France': types_1.Localization.HAUTS_DE_FRANCE,
    'Ile de France': types_1.Localization.ILE_DE_FRANCE,
    National: types_1.Localization.National,
    Normandie: types_1.Localization.NORMANDIE,
    'Nouvelle Aquitaine': types_1.Localization.NOUVELLE_AQUITAINE,
    Occitanie: types_1.Localization.OCCITANIE,
    'Pays de la Loire': types_1.Localization.PAYS_DE_LA_LOIRE,
    "Provence Alpes Côte d'Azur": types_1.Localization.PACA,
    Afrique: types_1.Localization.AFRIQUE,
    Amériques: types_1.Localization.AMERIQUE,
    Asie: types_1.Localization.ASIE,
    Europe: types_1.Localization.EUROPE,
    Océanie: types_1.Localization.OCEANIE,
    International: types_1.Localization.International
};
var toLocalization = function (prismicRegion, logger) {
    return logger.toConstValue(prismicRegion, LOCALIZATION_PRISMIC_TO_LGLP);
};
exports.toLocalization = toLocalization;
var toLocalizationFilter = function (prismicRegion, logger) {
    var region = exports.toLocalization(prismicRegion, logger);
    if (region && types_1.isInternational(region)) {
        return types_1.Localization.International;
    }
    return region;
};
exports.toLocalizationFilter = toLocalizationFilter;
//# sourceMappingURL=localization.js.map